import React from 'react';
import { ChevronLeft, ChevronRight, LayoutDashboard, BarChart3, CloudSun } from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab, isOpen, setIsOpen }) => {
    const navItems = [
        { id: 'dashboard', label: 'Dashboard', shortLabel: 'Dash', icon: LayoutDashboard },
        { id: 'site_intelligence', label: 'Site Intelligence', shortLabel: 'Site Int', icon: BarChart3 },
        { id: 'weather_data', label: 'Weather Data', shortLabel: 'Weather', icon: CloudSun },
    ];

    // Close sidebar on mobile when a tab is clicked
    const handleTabClick = (id) => {
        setActiveTab(id);
        if (window.innerWidth < 768) {
            setIsOpen(false);
        }
    };

    return (
        <>
            {/* Mobile Overlay */}
            <div 
                className={`md:hidden fixed inset-0 bg-black/50 z-[999] transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setIsOpen(false)}
            />
            
            {/* Sidebar */}
            <div 
                className={`fixed md:relative top-0 left-0 z-[1000] flex shrink-0 transition-all duration-300 ease-in-out h-full flex-col bg-white shadow-lg md:shadow-none border-r border-gray-200 ${
                    isOpen ? 'w-64 translate-x-0' : '-translate-x-full md:translate-x-0 md:w-20'
                }`}
            >
                <div className="flex flex-col h-full w-full">
                    {/* Logo Area */}
                    <div className="flex items-center justify-center border-b border-gray-100 shrink-0 transition-all duration-300" style={{ height: 'clamp(64px, 10vw, 80px)' }}>
                        <img 
                            src={isOpen ? `${process.env.PUBLIC_URL}/menu-logo.png` : `${process.env.PUBLIC_URL}/ags-icon.png`} 
                            alt="AGS Logo" 
                            className={isOpen ? "h-10 sm:h-12 object-contain" : "h-8 sm:h-10 object-contain"} 
                        />
                    </div>

                    {/* Navigation */}
                    <nav className="flex flex-1 overflow-y-auto py-4 flex-col justify-start">
                        {navItems.map((item) => {
                            const isActive = activeTab === item.id;
                            const Icon = item.icon;
                            return (
                                <div key={item.id} className="relative group flex w-full">
                                    <button
                                        onClick={() => handleTabClick(item.id)}
                                        className={`w-full flex transition-colors items-center px-6 py-3 mb-1 ${
                                            isOpen ? 'justify-start' : 'justify-center md:px-0'
                                        } ${
                                            isActive 
                                                ? 'bg-[#eef5e9] text-[#76AB3F] border-r-4 border-[#76AB3F]' 
                                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-r-4 border-transparent'
                                        }`}
                                    >
                                        <Icon size={20} className={`${isOpen ? 'mr-3' : ''} ${isActive ? 'text-[#76AB3F]' : 'text-gray-400'}`} />
                                        {isOpen ? (
                                            <span className="font-medium text-base">{item.label}</span>
                                        ) : (
                                            <span className="hidden md:inline text-[10px] font-semibold tracking-wide leading-none">{item.shortLabel}</span>
                                        )}
                                    </button>
                                    
                                    {/* Tooltip for collapsed state (Desktop only) */}
                                    {!isOpen && (
                                        <div className="hidden md:block absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-1.5 bg-gray-800 text-white text-sm font-medium rounded shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-[1100] transition-opacity">
                                            {item.label}
                                            <div className="absolute top-1/2 -left-1 -translate-y-1/2 border-y-4 border-y-transparent border-r-4 border-r-gray-800"></div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </nav>
                </div>

                {/* Toggle Button (Desktop Only) */}
                <button 
                    onClick={() => setIsOpen(!isOpen)}
                    className="hidden md:flex absolute z-[1010] bg-white border border-gray-200 shadow-sm rounded-full p-0.5 text-gray-500 hover:text-[#76AB3F] transition-all duration-300 items-center justify-center cursor-pointer"
                    style={{
                        top: 'calc(clamp(64px, 10vw, 80px) + 8px)',
                        transform: 'translateY(-50%)',
                        right: '-12px',
                        width: '24px',
                        height: '24px'
                    }}
                >
                    {isOpen ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
                </button>
            </div>
        </>
    );
};

export default Sidebar;
